<template>
    <v-container>
        <v-form ref="tradeShowForm">
            <v-row justify="center">
                <v-col cols="12" md="8">
                    <v-card class="pa-5">

                        <v-card-title class="mb-3">
                           Customer Info
                        </v-card-title>

                        <v-card-text>
                            <div id="customer-info-form" class="my-3">
                                                               
                                <!-- First Name Input -->
                                <v-text-field
                                    label="First Name"
                                    v-model="formData.First_Name"
                                    required
                                    :rules="validationRules.notEmpty"
                                ></v-text-field>

                                <!-- Last Name Input -->
                                <v-text-field
                                    label="Last Name"
                                    v-model="formData.Last_Name"
                                    required
                                    :rules="validationRules.notEmpty"
                                ></v-text-field>

                                <!-- Customer Did Not Provide Email Switch -->
                                <v-switch
                                    @click="noEmailHandler"
                                    label="Customer Did Not Provide Email"
                                    color="success"
                                    v-model="data.customerEmailState"
                                ></v-switch>

                                <!-- Email Input -->
                                <v-text-field
                                    v-if="!data.customerEmail"
                                    label="Email Address"
                                    v-model="formData.Email"
                                    :rules="validationRules.isEmail"
                                    placeholder="yourname@domain.com"
                                ></v-text-field>

                                <!-- Phone Input -->
                                <v-text-field
                                    label="Phone Number"
                                    v-model="formData.Phone"
                                    type="tel"
                                    required
                                    :rules="validationRules.isPhoneNumber"
                                    placeholder="xxx-xxx-xxxx"
                                ></v-text-field>

                                <!-- Text Message Opt Out -->
                                <v-switch
                                    label="Do Not Send Me Text Messages"
                                    color="success"
                                    v-model="formData.Text_Message_Opt_Out"
                                ></v-switch>

                                <!-- Lead Source Select -->
                                <v-select
                                    label="Lead Source"
                                    v-model="formData.Lead_Source"
                                    required
                                    :items="leadSources"
                                ></v-select>
                                
                            </div>
                            
                            <div class="my-3" id="contact-address-form">
                                <div class="px-1 mb-6 text-h6">Contact Address</div>

                                <!-- Market Select -->
                                <v-select
                                    label="Market"
                                    v-model="formData.Market"
                                    required
                                    :items="markets"
                                ></v-select>

                                <!-- Street Input -->
                                <v-text-field
                                    label="Street"
                                    v-model="formData.Street"
                                    required
                                    :rules="validationRules.notEmpty"
                                ></v-text-field>

                                <!-- City Input -->
                                <v-text-field
                                    label="City"
                                    v-model="formData.City"
                                    required
                                    :rules="validationRules.notEmpty"
                                ></v-text-field>

                                <!-- State Select -->
                                <v-select
                                    label="State"
                                    v-model="formData.State"
                                    required
                                    :items="states"
                                ></v-select>

                                <!-- Zip Code Input -->
                                <v-text-field
                                    label="Zip Code"
                                    v-model="formData.Zip_Code"
                                    required
                                    :rules="validationRules.isZipCode"
                                ></v-text-field>
                            </div>

                            <div class="my-3" id="service-address-form">
                                <div class="px-1 mb-1 text-h6">Service Address</div>

                                <!-- Copy Contact Address to Job Site Address -->
                                <v-switch
                                    label="Same as Contact Address"
                                    color="success"
                                    v-model="data.copyAddress"
                                    @click="copyAddressHandler"
                                ></v-switch>

                                <!-- container for job site address inputs, only shown if data.copyAddress == false -->
                                <div v-if="!data.copyAddress">
                                    <!-- Service Street Input -->
                                    <v-text-field
                                        label="Street"
                                        v-model="formData.Job_Site_Street"
                                        required
                                        :rules="validationRules.notEmpty"
                                    ></v-text-field>

                                    <!-- Service City Input -->
                                    <v-text-field
                                        label="City"
                                        v-model="formData.Job_Site_City"
                                        required
                                        :rules="validationRules.notEmpty"
                                    ></v-text-field>

                                    <!-- State Select -->
                                    <v-select
                                        label="State"
                                        v-model="formData.Job_Site_State"
                                        required
                                        :items="states"
                                    ></v-select>

                                    <!-- Zip Code Input -->
                                    <v-text-field
                                        label="Zip Code"
                                        v-model="formData.Job_Site_Zip_Code"
                                        required
                                        :rules="validationRules.isZipCode"
                                    ></v-text-field>
                                    </div>
                            </div>

                            <div class="my-3" id="service-info-form">
                                <div class="px-1 mb-6 text-h6">Service Information</div>
                                
                                <!-- Service Type Input -->
                                <div class="px-1 mb-1">Please select all that apply</div>
                                <v-select
                                    label="Service Type"
                                    :items="serviceTypes"
                                    multiple
                                    chips
                                    v-model="formData.Service_Type_Select_All_That_Apply"
                                    required
                                ></v-select>

                                <!-- Storm Damage Input -->
                                <v-select
                                    label="Storm Damage Suspected?"
                                    :items="['Yes','No', 'Unsure', 'Not Applicable']"
                                    v-model="formData.Storm_Damage_Suspected"
                                    required
                                ></v-select>

                                <!-- Description Input -->
                                <v-textarea
                                    label="Description of Services Needed"
                                    v-model="formData.Description"
                                ></v-textarea>

                                
                            </div>

                        </v-card-text>

                        <v-card-actions class="d-flex justify-center flex-wrap px-4">
                            <!-- check screen size, if screen is smaller than md or larger, make button a block element -->
                            <v-btn :block="!mdAndUp ? true : false" variant="elevated" color="primary" @click="submitHandler" class="ma-2">Submit</v-btn>
                            <v-btn :block="!mdAndUp ? true : false" variant="elevated" color="warning" @click="clearForm" class="ma-2">Clear</v-btn>
                        </v-card-actions>

                    </v-card>
                </v-col>
            </v-row>
        </v-form>

        <!-- Sending Form Modal -->
    <v-dialog
        v-model="data.isSending"
        :scrim="false"
        persistent
        class="w-50"
        min-width="200"
    >
        <v-card color="primary">
            <v-card-text>
                Submitting
                <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                >
                </v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>

    <!-- Form Submitted Successfully Modal -->
    <v-dialog
        v-model="data.isSuccess"
        :scrim="false"
        persistent
        class="w-50"
        min-width="200"
    >
        <v-card color="success">
            <v-card-text class="text-center">
                Successfully Submitted!
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
                <v-btn @click="data.isSuccess = !data.isSuccess">Ok</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- Email Error modal -->
    <v-dialog
        v-model="data.isError"
        :scrim="false"
        persistent
        class="w-50"
        min-width="200"
    >
        <v-card color="error">
            <v-card-text class="text-center">
                <div class="my-2">
                    There was a problem submitting the form:
                </div>
                <div class="my-2">
                    {{ (data.error).toUpperCase() }}
                </div>
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
                <v-btn @click="data.isError = !data.isError">Ok</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    </v-container>
</template>

<script setup>
import {reactive, ref} from 'vue';
//import form validators
import {validationRules} from '../utils/validators';

//import useDisplay to access current screensize for custom breakpoints
import {useDisplay} from 'vuetify';

//access user store
import { useUserStore } from '../stores/user';

const userStore = useUserStore();

//import  to call cloud functions
import { useInvokeCF } from '../composables/invokeCF.js';

//construct createReRoofLead cloud function object
const createReRoofLead = useInvokeCF('createReRoofLeadCF');

const { mdAndUp } = useDisplay();

//values for picklists
const serviceTypes = [
    'Commercial',
    'Duradek',
    'EPDM Roofing',
    'Gutters',
    'New Construction',
    'Roof Replacement',
    'Roof Repair',
    'Siding',
    'TPO Roofing',
    'Windows',
    'Other'
]

const states = [ 'AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY' ];

const markets = [
    'Atlanta',
    'Charlotte',
    'Charleston',
    'Greensboro',
    'Columbia',
    'Raleigh',
    'Greenville',
    'Nashville',
    'Myrtle Beach',
    'Knoxville',
    'Savannah',
    'Wilmington',
    'Johnston City',
    'Huntsville',
    'TBD'
];

const leadSources = [
    'Alpha Omega Website',
    'Call Center',
    'Customer Referral',
    'Business Card (Cold Call)',
    'Previous Customer',
    'Saw our Truck',
    'Yard Sign'
]

//ref to hold entire form element for validation
const tradeShowForm = ref(null);

//reactive state data of component
const data = reactive({
    copyAddress: false,
    selectedOwner: null,
    fetchState: 'standby',
    isSending: false,
    isSuccess: false,
    isError: false,
    response: null,
    error: null,
    customerEmail: false,
    customerEmailState: false,
});


//function that returns default values for the form    
const defaultValues = () => ({
    Service_Type_Select_All_That_Apply: null,
    First_Name: null,
    Last_Name: null,
    Phone: null,
    Text_Message_Opt_Out: false,
    Email: null,
    Street: null,
    City: null,
    State: null,
    Zip_Code: null,
    Job_Site_Street: null,
    Job_Site_City: null,
    Job_Site_State: null,
    Job_Site_Zip_Code: null,
    Storm_Damage_Suspected: null,
    Description: null,
    Market: null,
    Lead_Source: null,
})

//reactive state data of Form
//use API names of the corresponding fields in a Zoho lead record
const formData = reactive(defaultValues());

//copies values of contact address fields to Service Address fields when triggered
const copyAddressHandler = () => {

    if (!data.copyAddress) {
        formData.Job_Site_Street = formData.Street;
        formData.Job_Site_City = formData.City;
        formData.Job_Site_State = formData.State;
        formData.Job_Site_Zip_Code = formData.Zip_Code;
    }
    
}

const noEmailHandler = () => {
    //toggle customer email state
    data.customerEmail = !data.customerEmail;
    //if customer did not provide email, set email field to null
    if (data.customerEmail) {
        formData.Email = null;
    }
}

const submitHandler = async () => {

    //validate form
    const { valid } = await tradeShowForm.value.validate();

    //if form passes validation, continue
    if (valid) {
        const payload = { ...formData };

        //Append Owner and Layout properties to payload
        payload.Owner = getOwnerData();
        payload.Layout = {
            name: "ReRoof Sales",
            id: "4331172000000091055"
        }

        //append zoho-specific properties to payload
        payload.Webform_Source = "Live New Lead Form";
        payload.Company = `${formData.First_Name} ${formData.Last_Name}`;
        payload.Receptionist = userStore.profile.name;

        //use createReRoofLead CF object to invoke cloud function
        // and save response to reactive state
        data.fetchState = 'pending'
        data.isSending = true;
        data.response = await createReRoofLead.invokeCF(payload);

        if (data.response.data.data.length > 0) {

            const zohoResponse = data.response.data.data[0];
            data.isSending = false;

            if (zohoResponse.code === 'SUCCESS') {
                data.fetchState = 'resolved';
                data.isSuccess = true;
                // toggle switch for customer did not provide email
                if (data.customerEmail) {
                    noEmailHandler();
                    data.customerEmailState = false;
                }
                clearForm();
            } else {
                data.fetchState = 'rejected';
                data.isError = true;
                data.error = zohoResponse.message
                console.log('Error Response from Zoho: ',zohoResponse);
            }

        } else {
            data.fetchState = 'rejected';
            data.isError = true;
            data.error = zohoResponse.message
            console.log('Error Response from Zoho: ',zohoResponse);
        }

    }


};

const getOwnerData = () => {
    
    //select owner based on market
    if (formData.Market === "Charlotte" || formData.Market === "Greenville" ) {
        return {
            id: "4331172000001987036",
            name: "Charlotte ReRoof Manager"
        }
    } else if (formData.Market === "Columbia" || formData.Market === "Charleston" || formData.Market === "Myrtle Beach" || formData.Market === "Wilmington") {
        return {
            id: "4331172000001978566",
            name: "Charleston ReRoof Manager"
        }
    } else if (formData.Market === "Raleigh" || formData.Market === "Greensboro") {
        return {
            id: "4331172000001987087",
            name: "Bryan Glover"
        }
    } else {
        return {
            id: "4331172000011616001",
            name: "Dom Cioffi"
        }
    }

}

//replaces the formData with a fresh set of default values, clearing the form
//uses the .assign() method to replace the values of formData with the values from the object returned by defaultValues()
const clearForm = () => {

    data.selectedOwner = null;
    data.copyAddress = false;
    return Object.assign(formData, defaultValues());

};


</script>